function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.0001 17.3904C34.0001 16.2348 33.9045 15.0729 33.7006 13.9361H17.3411V20.4825H26.7094C26.3206 22.5938 25.0715 24.4615 23.2425 25.6484V29.896H28.8316C32.1137 26.9351 34.0001 22.5626 34.0001 17.3904Z",
  fill: "#4285F4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.341 34C22.0187 34 25.9636 32.4946 28.8379 29.896L23.2487 25.6484C21.6937 26.6853 19.6862 27.2725 17.3473 27.2725C12.8225 27.2725 8.98594 24.2804 7.60937 20.2576H1.8418V24.6364C4.78613 30.377 10.7831 34 17.341 34Z",
  fill: "#34A853"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.60301 20.2576C6.87649 18.1462 6.87649 15.86 7.60301 13.7487V9.36983H1.84181C-0.618169 14.1734 -0.618169 19.8328 1.84181 24.6364L7.60301 20.2576Z",
  fill: "#FBBC04"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.3409 6.72754C19.8137 6.69006 22.2035 7.60206 23.9944 9.27614L28.9462 4.42256C25.8107 1.53665 21.6491 -0.0499712 17.3409 1.20094e-06C10.7831 1.20094e-06 4.78612 3.623 1.8418 9.36983L7.60299 13.7487C8.97319 9.71964 12.8161 6.72754 17.3409 6.72754Z",
  fill: "#EA4335"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.a2a6d0d2.svg";
export { ForwardRef as ReactComponent };